/**
 * In-memory cache of decrypted data-page lists (stale-while-revalidate).
 *
 * Purpose: revisiting a data page paints instantly from cache while a
 * background refetch updates it, instead of re-downloading and re-decrypting
 * the whole list behind a full-page spinner every time.
 *
 * Security: plaintext lives in JS memory only (a Map in module scope) — the
 * same exposure as the React state that already holds the decrypted list.
 * Nothing is persisted to localStorage/sessionStorage. MUST be cleared on
 * logout (see clearListCache call in the auth logout handler) so a
 * follow-up login in the same tab can never see the previous user's data.
 */

const cache = new Map();

export const getCachedList = (key) => cache.get(key);

export const setCachedList = (key, items) => {
  cache.set(key, items);
};

export const clearListCache = () => {
  cache.clear();
};
